import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setGlobalNavigate } from "./Navigation";

// DONT REMOVE
const NavigationInitializer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  return null;
};

export default NavigationInitializer;
